var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path, _g, _path2, _path3, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnboardingIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 34,
    viewBox: "0 0 30 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.7565,
    height: 20.7726,
    rx: 2,
    transform: "matrix(0.995721 0.0924065 -0.0945373 0.995521 12.9058 0)",
    fill: "#FF7D19"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 15.7569,
    height: 20.7721,
    rx: 2,
    transform: "matrix(0.996801 -0.0799237 0.0817708 0.996651 8.07605 4.33252)",
    fill: "#A4FF00"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 15.7466,
    height: 20.7859,
    rx: 2,
    transform: "matrix(0.968249 -0.249986 0.255427 0.966828 4.24072 9.90576)",
    fill: "#291482"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 15.7269,
    height: 20.8124,
    rx: 2,
    transform: "matrix(0.910768 -0.412918 0.420839 0.907135 0.5 15.1213)",
    fill: "#FF8CF9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15.2544,
    y: 15.0361,
    width: 13.9067,
    height: 18.3316,
    rx: 1,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5233,
    y: 27.6787,
    width: 5.05698,
    height: 4.42486,
    rx: 0.5,
    fill: "#FCEA25"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5233,
    y: 21.9919,
    width: 5.05698,
    height: 4.42486,
    rx: 0.5,
    fill: "#A4FF00"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5233,
    y: 16.3003,
    width: 5.05698,
    height: 4.42486,
    rx: 0.5,
    fill: "#291482"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 22.8398,
    y: 27.6787,
    width: 5.05698,
    height: 4.42486,
    rx: 0.5,
    fill: "#F2F3F8"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 22.8398,
    y: 21.9919,
    width: 5.05698,
    height: 4.42486,
    rx: 0.5,
    fill: "#FF7D19"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 22.8398,
    y: 16.3003,
    width: 5.05698,
    height: 4.42486,
    rx: 0.5,
    fill: "#FF8CF9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2556_72734",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 16,
    width: 4,
    height: 4
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.60266 16.6208L4.91298 16.0267L6.10121 18.6474L4.79089 19.2415L3.60266 16.6208Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2556_72734)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.84748 18.1373L4.43693 16.5566C4.43551 16.555 4.43404 16.5536 4.43249 16.5521C4.30927 16.4238 4.12465 16.3842 3.9716 16.4536C3.76817 16.5458 3.68289 16.7978 3.7815 17.0153C3.80216 17.0608 3.82969 17.1022 3.86337 17.1385C3.86424 17.1396 3.86518 17.1407 3.86616 17.1418L5.25017 18.6922C5.37162 18.838 5.56967 18.8884 5.73228 18.8147C5.93571 18.7224 6.02098 18.4704 5.92238 18.253C5.90377 18.2119 5.87942 18.1741 5.84999 18.1403C5.84918 18.1393 5.84834 18.1383 5.84748 18.1373Z",
    fill: "#251B7D"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.96985 17.6802L6.11765 16.7441C6.11626 16.7426 6.11479 16.7411 6.11326 16.7398C5.98805 16.6123 5.79825 16.5749 5.6395 16.6469C5.42856 16.7425 5.33718 16.9972 5.43579 17.2147C5.45644 17.2603 5.48421 17.3015 5.51835 17.3375C5.51927 17.3386 5.52023 17.3398 5.52126 17.3409L6.34652 18.2469C6.46967 18.3919 6.67309 18.4398 6.84168 18.3634C7.05263 18.2677 7.144 18.013 7.0454 17.7955C7.02682 17.7545 7.00226 17.7168 6.97237 17.6832C6.97157 17.6822 6.97071 17.6812 6.96985 17.6802Z",
    fill: "#251B7D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2556_72734",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 15,
    width: 3,
    height: 2
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.82703 15.6172L6.63338 15.2516L7.13609 16.3603L6.32974 16.7259L5.82703 15.6172Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2556_72734)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.85434 15.8108C6.84101 15.7974 6.8265 15.7847 6.80909 15.7713C6.80732 15.7696 6.80546 15.768 6.8035 15.7665C6.8035 15.7665 6.79813 15.7623 6.78792 15.7555C6.78517 15.7536 6.78238 15.7517 6.77971 15.75C6.7246 15.7138 6.51906 15.5891 6.18822 15.5045C6.11392 15.4855 6.03849 15.5069 5.98633 15.5617C5.93453 15.6162 5.91533 15.6939 5.93494 15.7696C5.99126 15.9871 6.10551 16.2789 6.2232 16.4057C6.22524 16.4079 6.22724 16.4099 6.22926 16.4117C6.25128 16.4382 6.27604 16.4621 6.30289 16.4829C6.43429 16.5842 6.60473 16.6012 6.74434 16.5379C6.79021 16.5171 6.83277 16.4876 6.86949 16.4497C6.95078 16.3655 6.99397 16.2526 6.9911 16.1317C6.9882 16.0108 6.93965 15.8968 6.85434 15.8108Z",
    fill: "#251B7D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingIcon2);
export default __webpack_public_path__ + "static/media/onboarding-icon-2.913e91d946923e2adf6d8ae2a6a19317.svg";
export { ForwardRef as ReactComponent };